import "Layouts/default";

$(function () {
    $('[name="filter"]').on("change", function () {
        $(this).parents("form").trigger("submit");
    });
});
